import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { BsStopwatch } from 'react-icons/bs';
import Navbar from '../dashboard/navbar';
import Sidebar from '../dashboard/sidebar';
import useAuth from '../dashboard/useAuth';
import { FaArrowAltCircleLeft, FaArrowAltCircleRight, FaChevronDown, FaChevronUp, FaHeart, FaQuestionCircle } from 'react-icons/fa';
import { Button } from 'react-bootstrap';
import axios from 'axios';
import { getAuthToken } from '../../authToken';

const Terminer_jeux = () => {
    useAuth(); // Vérifier l'authentification
    const navigate = useNavigate();
    const user_id = localStorage.getItem('user_id');
    const [qcms, setQcms] = useState([]); // Liste des QCMs reçus du backend
    const [filteredQcms, setFilteredQcms] = useState([]); // Liste filtrée des QCMs
    const [nbreVie, setNbreVie] = useState(0); // Pourcentage de bonnes réponses
    const [results, setResults] = useState([]); // Total de bonnes réponses
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingBouton, setIsLoadingBouton] = useState(false);
    const [showInfo, setShowInfo] = useState(false);


    const location = useLocation();

    // Chargement des QCMs depuis le backend
    useEffect(() => {
        const fetchQuiz = async () => {
            setIsLoading(true)
            try {

                const token = localStorage.getItem('access_token');

                const response = await fetch(`${process.env.REACT_APP_HOTE}/recuperer-quiz/${user_id}/`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                });

                if (response.ok) {
                    const data = await response.json();
                    const allQcms = data.quiz_data.questions;
                    setNbreVie(data.quiz_data.nbre_vies);

                    // Calculer le nombre total de questions
                    const totalQuestions = allQcms.length;

                    // Filtrer les QCMs avec des résultats non vides
                    const nonEmptyQcms = allQcms.filter(qcm => qcm.resultats && qcm.resultats.trim() !== '');

                    // Calculer le nombre de bonnes réponses
                    const correctAnswers = nonEmptyQcms.filter(qcm => qcm.resultats === qcm.bonne_reponse).length;

                    // Mettre à jour les états pour afficher les résultats
                    setQcms(allQcms); // Toutes les questions
                    setFilteredQcms(nonEmptyQcms); // Questions avec des réponses
                    setResults({ correct: correctAnswers, total: totalQuestions }); // Bonnes réponses et total
                } else {
                    const data = await response.json();
                    console.error('Erreur lors de la récupération des quiz', data);
                }
            } catch (error) {
                console.error('Erreur réseau:', error);
            } finally {
                setIsLoading(false)
            }
        };

        fetchQuiz();
    }, [user_id]);



    const [currentPage, setCurrentPage] = useState(1);
    const itemsParPage = 5;
    const totalPages = Math.ceil(filteredQcms.length / itemsParPage);
    const debutIndex = (currentPage - 1) * itemsParPage;
    const finIndex = debutIndex + itemsParPage;
    const currentQcms = filteredQcms.slice(debutIndex, finIndex);

    const pageSuivante = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const pagePrecedente = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };



    const lancerQuiz = async () => {
        try {
            setIsLoadingBouton(true)

            const response = await fetch(`${process.env.REACT_APP_HOTE}/lancer-quiz/?user_id=${user_id}`, {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
            });

            if (response.ok) {
                const data = await response.json();
                setIsLoadingBouton(false)

                // Naviguer après le succès
                navigate('/Quizz-demarrer', { state: { quizData: data } });
            }
            setIsLoadingBouton(false)
        } catch (error) {
            // console.error('Erreur réseau:', error);
        }
    };

    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupe(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupe(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupe.includes("Quiz")) {
        return (
            <div id="wrapper">
                <Sidebar user_id={user_id} />
                <div id="page-wrapper" className="gray-bg">
                    <Navbar />
                    <div className="wrapper wrapper-content animated fadeInRight">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="ibox">
                                    <div className="ibox-content text-center p-5">
                                        <div className="mb-4">
                                            <i className="fa fa-lock fa-5x text-warning"></i>
                                        </div>
                                        <h2>Accès restreint</h2>
                                        <p className="lead mb-4">
                                            Vous n'avez pas les autorisations nécessaires pour accéder à cette page.
                                        </p>
                                        <div className="d-flex justify-content-center">
                                            <Link to="/" className="btn btn-primary">
                                                <i className="fa fa-arrow-left mr-2"></i>
                                                Retour
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <div className='row align-items-end'>
                                <h2><FaQuestionCircle size={25} className='mr-2' />Quiz
                                </h2>
                                <span
                                    className="ml-3 toggle-icon"
                                    style={{ cursor: 'pointer', marginBottom: '10px' }}
                                    onClick={() => setShowInfo(!showInfo)}
                                >
                                    {showInfo ? <FaChevronUp /> : <FaChevronDown />}
                                </span>
                            </div>

                            <div className={`info-box ${showInfo ? "open" : ""}`}>
                                <small>
                                    Résultat et correction du quiz. Les explications et les éventuelles références au Guide PMBOK aident à mieux comprendre la logique des questions. <br /><b>Légende des icônes : </b>
                                    <i className="fa fa-thumbs-o-up ivt-align-menu"></i> indique la bonne réponse,
                                    <i className="fa fa-thumbs-o-down ivt-align-menu"></i> indique la mauvaise réponse.
                                </small>
                            </div>
                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Quizz-form`}> Quiz </Link>
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    <div className="wrapper wrapper-content animated fadeInRight mt-3">
                        <div className="row d-flex justify-content-center">
                            <div className="col-lg-8 mx-auto">
                                <div className="ibox">
                                    <div className="ibox-title pr-3">
                                        <h5>Résultats du quiz</h5>
                                        <div className="table-responsive">
                                            <table className="table table-striped table-hover">
                                                <tbody>
                                                    <tr>
                                                        <td>Questions traitées : </td>
                                                        <td>{filteredQcms.length}/{results.total}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Bonnes réponses : </td>
                                                        <td>
                                                            {results.correct}/{results.total}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>Nombre de vies restantes : </td>
                                                        <td>
                                                            {/* {nbreVie} */}
                                                            <div className="hearts">
                                                                <div style={{ position: 'relative', display: 'inline-block' }}>
                                                                    <FaHeart size={30} className="text-danger mb-1 mr-2" />
                                                                    <span
                                                                        style={{
                                                                            position: 'absolute',
                                                                            // top: 'px',
                                                                            right: '9px',
                                                                            fontSize: '15px',
                                                                            fontWeight: 'bold',
                                                                            color: 'white',
                                                                            // backgroundColor: 'red',
                                                                            borderRadius: '50%',
                                                                            padding: '2px 6px',
                                                                            minWidth: '18px',
                                                                            textAlign: 'center',
                                                                        }}
                                                                    >
                                                                        {nbreVie.toString().padStart(2, '0')}
                                                                    </span>
                                                                </div>
                                                            </div>

                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    {!isLoading ? (
                                        <div className="ibox-content text-dark">
                                            {currentQcms.length > 0 ? (
                                                currentQcms.map((qcm) => (
                                                    <div key={qcm.id} style={{ borderBottom: '1px solid #ccc', paddingBottom: '15px', marginBottom: '15px' }}>
                                                        <div>
                                                            <span># {qcm.id} - </span>
                                                            <span id="question" style={{ fontSize: '13px' }} dangerouslySetInnerHTML={{ __html: qcm.question }}></span>
                                                        </div>
                                                        <div style={{ margin: '10px 10px' }}>
                                                            {qcm.reponses.map((option, optionIndex) => (
                                                                <div key={option} style={{ display: 'flex', alignItems: 'center', marginBottom: '10px', fontSize: '12px' }}>
                                                                    <span style={{ marginRight: '2px' }}>
                                                                        {optionIndex + 1} - {option}
                                                                    </span>
                                                                    {qcm.resultats === option && qcm.resultats === qcm.bonne_reponse ? (
                                                                        <i className="fa fa-thumbs-o-up fa-2x" style={{ color: 'green', marginLeft: '5px' }}></i>
                                                                    ) : qcm.resultats === option ? (
                                                                        <i className="fa fa-thumbs-o-down fa-2x" style={{ color: 'red', marginLeft: '5px' }}></i>
                                                                    ) : qcm.bonne_reponse === option ? (
                                                                        <i className="fa fa-thumbs-o-up fa-2x" style={{ color: 'green', marginLeft: '5px' }}></i>
                                                                    ) : null}
                                                                </div>
                                                            ))}
                                                        </div>
                                                        {qcm.explication && (
                                                            <div style={{ color: 'green' }}>
                                                                <span>Explication : </span>
                                                                <span id="explication" style={{ fontSize: '12px', color: 'green', marginTop: '10px' }} dangerouslySetInnerHTML={{ __html: qcm.explication }} />
                                                            </div>
                                                        )}
                                                    </div>
                                                ))
                                            ) : (
                                                <p>Aucune question avec résultat trouvé pour ce quiz.</p>
                                            )}

                                            {/* Pagination controls */}
                                            {totalPages > 1 && (
                                                <div className="d-flex justify-content-between mt-4">
                                                    <Button
                                                        className="btn btn-success"
                                                        disabled={currentPage === 1}
                                                        onClick={pagePrecedente}
                                                    >
                                                        <FaArrowAltCircleLeft />
                                                    </Button>
                                                    <span>Page {currentPage} sur {totalPages}</span>
                                                    <Button
                                                        className="btn btn-success"
                                                        disabled={currentPage === totalPages}
                                                        onClick={pageSuivante}
                                                    >
                                                        <FaArrowAltCircleRight />
                                                    </Button>
                                                </div>
                                            )}

                                            <div className="d-flex justify-content-end mt-4">
                                                {!isLoadingBouton ? (
                                                    <Button
                                                        className='btn btn-success d-flex align-items-center justify-between'
                                                        // onClick={lancerQuiz}
                                                        onClick={() => navigate('/Quizz-form')}
                                                    >
                                                        <FaArrowAltCircleLeft className='mr-1' />
                                                        <span className="d-none d-sm-inline">
                                                            Retour au quiz
                                                        </span>
                                                    </Button>
                                                ) : (
                                                    <div className="d-flex justify-content-center align-items-center">
                                                        <span
                                                            className="spinner-border spinner-border-lg text-success"
                                                            role="status"
                                                            aria-hidden="true"
                                                            style={{ width: '1rem', height: '1rem' }}
                                                        ></span>
                                                    </div>
                                                )}

                                            </div>
                                        </div>
                                    ) : (

                                        <div className="mt-3 d-flex justify-content-center align-items-center" style={{ height: '100%', width: '100%' }}>
                                            <span
                                                className="spinner-border spinner-border-lg text-success"
                                                role="status"
                                                aria-hidden="true"
                                                style={{ width: '3rem', height: '3rem' }}
                                            ></span>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Terminer_jeux;
